import {
  Box,
  Button,
  Grid,
  IconButton,
  styled,
  SwipeableDrawer,
  Toolbar
} from '@mui/material';
import { useState } from 'react';
import MuiAppBar from '@mui/material/AppBar';
import {
  colorAppBackground,
  colorPureWhite,
  colorSecondary
} from '../../config/theme';
import { drawerWidth } from '../../utils/constant';
import { IMG_SPLASH_LOGO } from '../../utils/imageUrls';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toggleExpandMenu } from '../../redux/reducers/layoutSlice';
import { Menu } from '@mui/icons-material';

const ResourcesLiteVersion = ({ Component }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: prop => prop !== 'open'
  })(({ theme, open }) => ({
    ...(open &&
      {
        // width: `calc(100% - ${drawerWidth}px)`,
        // marginLeft: `${drawerWidth}px`
      })
  }));

  const Main = styled('main', { shouldForwardProp: prop => prop !== 'open' })(
    ({ theme, open }) => ({
      flexGrow: 1,
      marginTop: 70,
      padding: theme.spacing(3),
      marginLeft: open ? `${drawerWidth}px` : '106px',
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      '@media (max-width: 600px)': {
        opacity: open ? 0.1 : 1
      }
    })
  );

  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'space-between'
  }));

  return (
    <Box
      sx={{
        backgroundColor: colorAppBackground,
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto'
      }}
    >
      <AppBar
        sx={{
          backgroundColor: colorAppBackground
        }}
        elevation={0}
        position="static"
        open={sidebarOpen}
      >
        {/* Header */}
        <AppBar
          elevation={0}
          position="fixed"
          sx={{
            width: sidebarOpen
              ? `calc(100% - ${drawerWidth}px)`
              : `calc(100% - 100px)`,
            marginLeft: sidebarOpen ? `${drawerWidth}px` : '100px',
            backgroundColor: colorPureWhite
          }}
        >
          <Toolbar>
            <Grid
              containter="true"
              display={'flex'}
              width={'100%'}
              justifyContent={'flex-end'}
            >
              <Button
                sx={{
                  width: '106px',
                  height: '42px',
                  boxShadow: 'none',
                  fontWeight: '700',
                  fontSize: '14px'
                }}
                variant="contained"
                onClick={() => navigate('/login')}
              >
                Sign In
              </Button>
            </Grid>
          </Toolbar>
        </AppBar>

        {/* SideBar */}
        <SwipeableDrawer
          open={true}
          onClose={() => {
            setSidebarOpen(false);
          }}
          onOpen={() => {
            setSidebarOpen(true);
          }}
          sx={{
            width: sidebarOpen ? drawerWidth : 106,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: sidebarOpen ? drawerWidth : 106,
              boxSizing: 'border-box',
              bgcolor: colorSecondary,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              border: 'none'
            }
          }}
          variant="persistent"
          anchor="left"
        >
          <DrawerHeader
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              alignSelf: 'flex-start',
              marginTop: 2
            }}
          >
            <Box
              role="presentation"
              sx={{ cursor: 'pointer' }}
              onClick={() => navigate('/login')}
            >
              <img
                style={{
                  // display: 'block',
                  margin: '15px 15px'
                }}
                height={sidebarOpen ? 65 : 45}
                width={sidebarOpen ? 65 : 45}
                src={IMG_SPLASH_LOGO}
                alt="IMG_SPLASH_LOGO"
              />
            </Box>

            <IconButton
              sx={{
                display: 'flex',
                padding: '0px',
                alignSelf: 'flex-start',
                mx: 3
              }}
              onClick={() => {
                dispatch(toggleExpandMenu(null));
                setSidebarOpen(!sidebarOpen);
              }}
            >
              {sidebarOpen ? (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5 15L7.5 10L12.5 5"
                    stroke="#1F2933"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <Menu />
              )}
            </IconButton>
          </DrawerHeader>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'self-end',
              justifyContent: 'center',
              textAlign: 'center',
              alignSelf: 'center',
              marginTop: 'auto',
              marginBottom: '10px',
              height: { lg: '80%', xl: '80%', md: '75%' },
              width: { lg: '80%', xl: '75%', md: '75%' }
            }}
          >
            {!sidebarOpen ? <Box sx={{ position: 'fixed' }}></Box> : <></>}
          </Box>
        </SwipeableDrawer>

        {/* Main Content */}
        <Main open={sidebarOpen}>
          <Component />
        </Main>
      </AppBar>
    </Box>
  );
};

export default ResourcesLiteVersion;
